// Acciones de estado
export const SET_EXAM = 'SET_EXAM';
export const SET_IS_FETCHING = 'SET_IS_FETCHING';
export const SET_CHANGING_PAGE = 'SET_CHANGING_PAGE';
export const SET_SENDING = 'SET_SENDING';
export const SET_ERROR = 'SET_ERROR';
export const SET_MESSAGE = 'SET_MESSAGE';
export const SET_ALERT = 'SET_ALERT';
export const SET_VERIFY = 'SET_VERIFY';

// Acciones de operaciones
export const GET_EXAM = 'GET_EXAM';
export const SEEN_INDUCTION = 'SEEN_INDUCTION';
export const SENDING = 'SENDING';
export const SEND_QUESTIONARY = 'SEND_QUESTIONARY';
export const ERROR_EXAM = 'ERROR_EXAM';
export const UNATORIZED = 'UNATORIZED';

